import { render, staticRenderFns } from "./PrepaidsUpdate.vue?vue&type=template&id=d388458c"
import script from "./PrepaidsUpdate.vue?vue&type=script&lang=js"
export * from "./PrepaidsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports